module.exports = __webpack_public_path__ + "static/media/top-nfts-12.2391371b.jpg";